module.exports = __webpack_public_path__ + "img/cashback_1248.affef005.png";